/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/droppable';
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';

import VueI18n from 'vue-i18n';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import vuetify from './plugins/vuetify';

import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './middlewares/i18n';
import 'jquery-ui-touch-punch/jquery.ui.touch-punch.min';
import '@/middlewares/axiosConfig';
import '@/assets/css/styles.scss';

Vue.component('splitpanes', Splitpanes);
Vue.component('pane', Pane);

Vue.config.productionTip = false;

Vue.use(VueI18n);

// Add vuelidate for form validation
Vue.use(Vuelidate);

// Vue.use(mavonEditor);

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
